import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-image-landing',
  templateUrl: './image-landing.component.html',
  styleUrls: ['./image-landing.component.scss']
})
export class ImageLandingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
